<ng-container *ngIf="flexible; else YearSelector">
  <div class="checkbox-enhanced">
    <input
      type="checkbox"
      [(ngModel)]="useYearDate"
      (ngModelChange)="onUseYearDateChange($event)"
    />
    <label> Use year start date </label>
  </div>

  <app-date-input
    *ngIf="!useYearDate; else YearSelector"
    appValidationContext
    [minDate]="startDate"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    (blur)="onTouched()"
  >
    <div *invalidMessageFor="'minDate' as error">
      Date must be on or after {{ error.minDate | aadate }}
    </div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </app-date-input>
</ng-container>

<ng-template #YearSelector>
  <select
    *ngIf="items.length > 0"
    appFormControl
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    (blur)="onTouched()"
    [disabled]="isDisabled"
  >
    <option value="">
      <ng-container *ngIf="allowEmpty; else Select">First Use</ng-container>
      <ng-template #Select>Select&hellip;</ng-template>
    </option>
    <option *ngFor="let item of items" [ngValue]="item.value">
      {{ item.displayLabel }}
    </option>
  </select>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
